import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'
import type { CampaignItem, CampaignListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

// `campaigns` returns CampaignItem (no version/createdDate/updatedDate); `campaign` returns
// the full AdCampaign. The two documents therefore select different field sets.
const LIST_QUERY = graphql(`
  query AdCampaigns($search: String, $pagination: PaginationInput, $sort: SortInput) {
    campaigns(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        type
        platform
        name
        vendorCampaignId
        accountId
        accountName
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query AdCampaign($id: ID!) {
    campaign(id: $id) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      type
      platform
      name
      vendorCampaignId
      accountId
      accountName
    }
  }
`)

export class AdCampaignStore extends EntityStore<CampaignItem, CampaignListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.campaigns,
      extractOne: (data: any) => data.campaign,
    })
  }
}
